export default __webpack_public_path__ + "static/media/photo_three.43a5bc97.jpg";